// extracted by mini-css-extract-plugin
export default {"app":"styles_app__adGTK","header":"styles_header__nMH52","resetBtn":"styles_resetBtn__hmmEz"};